import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import logoImg from '../assets/logo.png'; // Import logo from assets

export default function Navbar({ user, onLogout }) {
  const location = useLocation();

  return (
    <nav className="navbar navbar-expand-lg navbar-dark sticky-top shadow-sm py-2"
        style={{backgroundColor:"#007C9D"}}
    >
      <div className="container-fluid px-4">
        
        {/* Brand Logo & Name */}
        <Link className="navbar-brand d-flex align-items-center fw-bold" to="/">
          <img 
            src={logoImg} 
            alt="Holisticphysiotherapy Logo" 
            style={{ height: '40px', width: 'auto', objectFit: 'contain' }}
            className="me-2 bg-white rounded p-1"
          />
          <span className="fs-5">Holistic Physiotherapy</span>
        </Link>

        {/* Mobile Toggle Button */}
        <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navigation Links */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto ms-3">
            <li className="nav-item">
              <Link className={`nav-link ${location.pathname === '/' ? 'active fw-bold' : ''}`} to="/">
                Patient Registration
              </Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link ${location.pathname === '/billing' ? 'active fw-bold' : ''}`} to="/billing">
                New Billing
              </Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link ${location.pathname === '/duplicate-bill' ? 'active fw-bold' : ''}`} to="/duplicate-bill">
                Duplicate Bill
              </Link>
            </li>
            <li className="nav-item">
            <Link className={`nav-link ${location.pathname === '/reports' ? 'active fw-bold' : ''}`} to="/reports">
                Reports
            </Link>
            </li>
          </ul>

          {/* User Info & Logout Button */}
          <div className="d-flex align-items-center mt-2 mt-lg-0">
            <span className="badge bg-light text-dark me-3 py-2 px-3 border shadow-sm">
              👤 {user?.full_name || user?.username}
            </span>
            <button onClick={onLogout} className="btn btn-outline-light btn-sm fw-bold px-3">
              🚪 Logout
            </button>
          </div>
        </div>

      </div>
    </nav>
  );
}